<template>
  <div class="text-center px-14">
    <div class="flex justify-center mb-32 lg:mb-58">
      <picture>
        <img class="object-cover h-186 lg:h-202" :src="emptyImage" alt="empty cart">
      </picture>
    </div>
    <div class="text-18 lg:text-24 font-bold mb-16 lg:mb-28 uppercase">Your Cart is Empty!</div>
    <div class="text-16 lg:text-18 text-dark-gray px-20">
      Looks like you haven't selected any artworks to your cart yet.
    </div>
    <div class="py-40 px-20">
      <a href="/artworks">
        <button class="w-full bg-orange text-white py-24 rounded-md uppercase cursor-pointer focus:outline-none">
          Browse Artwork
        </button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    emptyImage () {
      return jsonFromPage('#data-empty-cart-image')
    },
  },
}
</script>